import React, { useState, useEffect } from "react";
import logo from "../../../assets/Mantelzorg.png";
import Form from "../../../components/Form";
import InputField from "../../../components/InputField";
import Api from "../../../Api";

const labelStyles = {
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "1.2",
  marginTop: "0",
  marginBottom: ".5rem",
  textAlign: "left",
};

const inputStyles = {
  paddingTop: ".5rem",
  paddingNottom: ".5rem",
  paddingLeft: "1rem",
  display: "block",
  width: "100%",
  padding: ".375rem .75rem",
  fontSize: "1rem",
  fontWeight: "400",
  lineHeight: "1.5",
  color: "#212529",
  backgroundColor: "#fff",
  backgroundClip: "padding-box",
  border: "1px solid #ced4da",
  height: "45px",
  borderRadius: ".25rem",
  transition: "border-color .15s ease-in-out, box-shadow .15s ease-in-out",
};

const Mantelzorgcompliment = (props) => {
  const [loading, setLoading] = useState(false);
  const [showModalSucces, setShowModalSucces] = useState(false);
  const [showModalError, setShowModalError] = useState(false);
  const [showBlockingModal, setShowBlockingModal] = useState(true);

  useEffect(() => {
    setShowBlockingModal(true);
  }, []);

  const submitForm = async (data) => {
    try {
      setLoading(true);
      const datas = {
        defDossier: 4208,
        ...data,
        85451: [43283],
        94196: [48884],
      };
      await Api.dossiers.Create(datas, "API_ZVHC_USERNAME", "API_ZVHC_KEY");
      props.reset();
      setLoading(false);
      setShowModalSucces(true);
    } catch (error) {
      setLoading(false);
      setShowModalError(true);
    }
  };

  return (
    <>
      {showBlockingModal && (
        <div
          id="blockingModal"
          tabindex="-1"
          aria-hidden="false"
          class="flex overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-modal md:h-full"
        >
          <div className="bg-slate-500 absolute w-full h-full opacity-50"></div>
          <div class="relative p-4 w-full max-w-md h-full md:h-auto">
            <div class="relative p-4 text-center bg-white rounded-lg shadow dark:bg-gray-800 sm:p-5">
              
              <p class="mb-4 text-lg font-semibold text-gray-900">
                Dit formulier is op dit moment niet beschikbaar. Het zal begin volgend jaar weer geopend worden.
              </p>
            </div>
          </div>
        </div>
      )}
      {loading && (
        <div className="flex items-center justify-center h-screen fixed w-full z-50">
          <div className="bg-slate-500 absolute w-full h-full  opacity-50"></div>
          <div class="relative">
            <div className="h-24 w-24 rounded-full border-t-8 border-b-8 border-slate-200"></div>
            <div className="absolute top-0 left-0 h-24 w-24 rounded-full border-t-8 border-b-8 border-slate-300 animate-spin"></div>
          </div>
        </div>
      )}
      {showModalError && (
        <div
          id="successModal"
          tabindex="-1"
          aria-hidden="true"
          class="flex  overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-modal md:h-full"
        >
          <div className="bg-slate-500 absolute w-full h-full opacity-50"></div>
          <div class="relative p-4 w-full max-w-md h-full md:h-auto">
            <div class="relative p-4 text-center bg-white rounded-lg shadow dark:bg-gray-800 sm:p-5">
              <button
                onClick={() => {
                  setShowModalError(false);
                }}
                type="button"
                class="text-gray-400 absolute top-2.5 right-2.5 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                data-modal-toggle="successModal"
              >
                <svg
                  aria-hidden="true"
                  class="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
                <span class="sr-only">Close modal</span>
              </button>
              <div class="w-12 h-12 rounded-full bg-red-100 dark:bg-red-900 p-2 flex items-center justify-center mx-auto mb-3.5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="w-8 h-8 text-red-500 dark:text-red-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>

                <span class="sr-only">error</span>
              </div>
              <p class="mb-4 text-lg font-semibold text-gray-900 dark:text-white">
                Er is een probleem opgetreden bij het verzenden van de gegevens.
              </p>
              <button
                onClick={() => {
                  setShowModalError(false);
                }}
                type="button"
                class="py-2 px-3 text-sm font-medium text-center text-white rounded-lg bg-yellow-500 hover:bg-yellow-700 focus:ring-4 focus:outline-none focus:ring-yellow-300 "
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      )}
      {showModalSucces && (
        <div
          id="successModal"
          tabindex="-1"
          aria-hidden="true"
          class="flex h-screen  overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-modal md:h-full"
        >
          <div className="bg-slate-500 absolute w-full h-full opacity-50"></div>
          <div class="relative p-4 w-full flex  justify-center items-center  max-w-md h-full md:h-auto">
            <div class="relative p-4 text-center bg-white rounded-lg shadow dark:bg-gray-800 sm:p-5">

              <div class="w-12 h-12 rounded-full bg-green-100 dark:bg-green-900 p-2 flex items-center justify-center mx-auto mb-3.5">
                <svg
                  aria-hidden="true"
                  class="w-8 h-8  text-white"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
                <span class="sr-only">Success</span>
              </div>
              <p class="mb-4 text-lg font-semibold text-black dark:text-white">
                Jouw aanvraag is verzonden naar het steunpunt, bedankt! Je ontvangt binnen 3 weken bevestiging dat je aanvraag is ontvangen.
              </p>
              <a
                href="https://www.mantelzorgverlicht.nl"
                onClick={() => {
                  setShowModalSucces(false);
                  props.reset();
                }}
                target="_blank"
                type="button"
                class="py-2 px-3 text-sm font-medium text-center text-white rounded-lg bg-yellow-500 hover:bg-yellow-700 focus:ring-4 focus:outline-none focus:ring-yellow-300 "
              >
                Afsluiten
              </a>
            </div>
          </div>
        </div>
      )}
      <div className="flex flex-col items-center  bg-[#f8f9fa] px-4 lg:px-0 py-10">
        <div className="w-full p-4 lg:p-0  lg:w-4/5">
          <h1 className="text-3xl text-left w-full text-yellow-500 mb-6">
            Aanvraag mantelzorgcompliment
          </h1>

          <div className="flex flex-col lg:flex-row items-center gap-6 border-2 border-yellow-400 p-6 ">
            <div className="flex-1 space-y-4 text-gray-700 text-justify">
              <p>
                In 2025 zijn we van start gegaan met een nieuw
                registratiesysteem. Hierdoor kan het mantelzorgcompliment alleen
                aangevraagd worden via een nieuwe aanvraag. Je komt in 2025 in
                aanmerking voor het mantelzorgcompliment als je:
              </p>
              <ul className="list-disc pl-8">
                <li>Zorgvrager in Eindhoven of Valkenswaard woont</li>
                <li>
                  Drie aaneengesloten maanden tenminste acht uur per week
                  mantelzorg hebt verleend.
                </li>
                <li>Meer dan de gebruikelijke zorg hebt gegeven</li>
                <li>
                  Niet betaald wordt uit een Persoons Gebonden Budget (PGB)
                </li>
              </ul>
              <p>
                {" "}
                Als het formulier via de website verstuurd is, ontvang je via de E-mail of post een ontvangstbevestiging.
              </p>
            </div>
            <img
              src={logo}
              alt="Logo"
              className="w-32 h-20 lg:w-40 lg:h-24 object-contain"
            />
          </div>

          <Form
            className="flex flex-col gap-8 mt-10 "
            {...props}
            onSubmit={submitForm}
            defDossier={3700}
          >
            <h2 className="text-2xl font-semibold text-gray-800 border-b border-gray-200 pb-1">
              Mantelzorger
            </h2>
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3">
              <InputField
                {...props}
                errors={props.formState.errors}
                type="text"
                label="Voornaam"
                name={"101817"}
                labelStyles={labelStyles}
                styles={inputStyles}
              />

              <InputField
                {...props}
                errors={props.formState.errors}
                type="text"
                label="Achternaam"
                name={"101816"}
                labelStyles={labelStyles}
                styles={inputStyles}
                rules={{
                  required: "Dit veld is verplicht",
                }}
              />
              <InputField
                {...props}
                errors={props.formState.errors}
                type="select"
                label="Geslacht"
                name={"101810"}
                options={[
                  {
                    value: "36270",
                    label: "Man",
                  },
                  {
                    value: "36275",
                    label: "Vrouw",
                  },
                  {
                    value: "36278",
                    label: "Onbekend",
                  },
                ]}
                labelStyles={labelStyles}
                styles={inputStyles}
              />
              <InputField
                {...props}
                errors={props.formState.errors}
                type="date"
                label="Geboortedatum"
                name={"101811"}
                labelStyles={labelStyles}
                styles={inputStyles}
                rules={{
                  required: "Dit veld is verplicht",
                }}
              />
              <InputField
                {...props}
                errors={props.formState.errors}
                type="email"
                label="Emailadres"
                name={"101808"}
                labelStyles={labelStyles}
                styles={inputStyles}
                rules={{
                  required: "Dit veld is verplicht",
                }}
              />

              <InputField
                {...props}
                errors={props.formState.errors}
                type="phone"
                label="Telefoonnummer"
                name={"101809"}
                labelStyles={labelStyles}
                styles={inputStyles}
              />

              <InputField
                {...props}
                errors={props.formState.errors}
                type="text"
                label="Straatnaam"
                name={"101815"}
                labelStyles={labelStyles}
                styles={inputStyles}
              />

              <div className="flex gap-6">
                <InputField
                  {...props}
                  errors={props.formState.errors}
                  type="text"
                  label="Huisnummer"
                  name={"101814"}
                  labelStyles={labelStyles}
                  styles={inputStyles}
                  rules={{
                    required: "Dit veld is verplicht",
                  }}
                />
                <InputField
                  {...props}
                  errors={props.formState.errors}
                  type="text"
                  label="Postcode"
                  name={"36113"}
                  labelStyles={labelStyles}
                  styles={inputStyles}
                  rules={{
                    required: "Dit veld is verplicht",
                  }}
                />
              </div>

              <InputField
                {...props}
                errors={props.formState.errors}
                type="text"
                label="Woonplaats"
                name={"101812"}
                labelStyles={labelStyles}
                styles={inputStyles}
              />
            </div>
            <div className="flex gap-6 items-center">
              <InputField
                {...props}
                errors={props.formState.errors}
                type="select"
                label="Heb jij in 2024 van onderstaande zorgvrager een Mantelzorgcompliment ontvangen? "
                name={"103368"}
                options={[
                  {
                    value: 36276,
                    label: "Ja",
                  },
                  {
                    value: 36273,
                    label: "Nee",
                  },
                ]}
                className="col-span-2"
                labelStyles={labelStyles}
                styles={inputStyles}
              />
              <InputField
                {...props}
                errors={props.formState.errors}
                type="select"
                label="Vind je het fijn als de mantelzorgconsulent telefonisch contact met je opneemt?"
                name={"106007"}
                options={[
                  {
                    value: 36276,
                    label: "Ja",
                  },
                  {
                    value: 36273,
                    label: "Nee",
                  },
                ]}
                className="col-span-2"
                labelStyles={labelStyles}
                styles={inputStyles}
              />
            </div>

            <h2 className="text-2xl font-semibold text-gray-800 border-b border-gray-200 pb-1">
              Zorgvrager
            </h2>
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3">
              <InputField
                {...props}
                errors={props.formState.errors}
                type="text"
                label="Voornaam"
                name={"101827"}
                labelStyles={labelStyles}
                styles={inputStyles}
              />

              <InputField
                {...props}
                errors={props.formState.errors}
                type="text"
                label="Achternaam"
                name={"101826"}
                labelStyles={labelStyles}
                styles={inputStyles}
                rules={{
                  required: "Dit veld is verplicht",
                }}
              />
              <InputField
                {...props}
                errors={props.formState.errors}
                type="select"
                label="Geslacht"
                name={"101819"}
                options={[
                  {
                    value: "36270",
                    label: "Man",
                  },
                  {
                    value: "36275",
                    label: "Vrouw",
                  },
                  {
                    value: "36278",
                    label: "Onbekend",
                  },
                ]}
                labelStyles={labelStyles}
                styles={inputStyles}
              />
              <InputField
                {...props}
                errors={props.formState.errors}
                type="date"
                label="Geboortedatum"
                name={"101828"}
                labelStyles={labelStyles}
                styles={inputStyles}
                rules={{
                  required: "Dit veld is verplicht",
                }}
              />
              <InputField
                {...props}
                errors={props.formState.errors}
                type="email"
                label="Emailadres"
                name={"101825"}
                labelStyles={labelStyles}
                styles={inputStyles}
                rules={{
                  required: "Dit veld is verplicht",
                }}
              />

              <InputField
                {...props}
                errors={props.formState.errors}
                type="phone"
                label="Telefoonnummer"
                name={"101824"}
                labelStyles={labelStyles}
                styles={inputStyles}
              />

              <InputField
                {...props}
                errors={props.formState.errors}
                type="text"
                label="Straatnaam"
                name={"101821"}
                labelStyles={labelStyles}
                styles={inputStyles}
              />

              <div className="flex gap-6">
                <InputField
                  {...props}
                  errors={props.formState.errors}
                  type="text"
                  label="Huisnummer"
                  name={"101822"}
                  labelStyles={labelStyles}
                  styles={inputStyles}
                  rules={{
                    required: "Dit veld is verplicht",
                  }}
                />
                <InputField
                  {...props}
                  errors={props.formState.errors}
                  type="text"
                  label="Postcode"
                  name={"101823"}
                  labelStyles={labelStyles}
                  styles={inputStyles}
                  rules={{
                    required: "Dit veld is verplicht",
                  }}
                />
              </div>

              <InputField
                {...props}
                errors={props.formState.errors}
                type="text"
                label="Woonplaats"
                name={"101820"}
                labelStyles={labelStyles}
                styles={inputStyles}
              />
            </div>

            <div className="text-2xl font-semibold text-gray-800 border-b border-gray-200 pb-1"></div>
            <div className="grid gap-6 grid-cols-1 md:grid-cols-2  lg:grid-cols-4">
              <InputField
                {...props}
                errors={props.formState.errors}
                type="select"
                label="Gemeente"
                name={"88868"}
                options={[
                  {
                    value: 36106,
                    label: "Eindhoven",
                  },
                  {
                    value: 36104,
                    label: "Valkenswaard",
                  },
                  {
                    value: 49226,
                    label: "Elders",
                  },
                ]}
                className=""
                labelStyles={labelStyles}
                styles={inputStyles}
                rules={{
                  required: "Dit veld is verplicht",
                }}
              />
              <InputField
                {...props}
                errors={props.formState.errors}
                type="select"
                label="Zorgsituatie"
                name={"105723"}
                options={[
                  {
                    value: 48844,
                    label: "Verstandelijke beperking",
                  },
                  {
                    value: 42622,
                    label: "Niet Aangeboren Hersenschade (NAH)",
                  },
                  {
                    value: 42621,
                    label: "Dementie",
                  },
                  {
                    value: 42620,
                    label: "Zorgintensief kind",
                  },
                  {
                    value: 42623,
                    label: "Psychische problemen",
                  },
                  {
                    value: 42624,
                    label: "Palliatieve zorg",
                  },
                  {
                    value: 42764,
                    label: "Anders",
                  },
                ]}
                rules={{
                  required: "Dit veld is verplicht",
                }}
                className="col-span-2"
                labelStyles={labelStyles}
                styles={inputStyles}
              />
              {props.getValues("88868") == 36106 && (
                <>
                  <InputField
                    {...props}
                    errors={props.formState.errors}
                    type="text"
                    label="IBAN nummer"
                    name={"86416"}
                    rules={{ required: true }}
                    className=""
                    labelStyles={labelStyles}
                    styles={inputStyles}
                  />
                  <InputField
                    {...props}
                    errors={props.formState.errors}
                    type="text"
                    label="T.n.v "
                    name={"85441"}
                    rules={{ required: true }}
                    labelStyles={labelStyles}
                    styles={inputStyles}
                  />
                </>
              )}
              <InputField
                {...props}
                errors={props.formState.errors}
                type="textarea"
                label="Toelichting zorgsituatie "
                name={"85442"}
                className="col-span-4"
                labelStyles={labelStyles}
                styles={{ ...inputStyles, height: "150px" }}
                rules={{
                  required: "Dit veld is verplicht",
                }}
              />
              <InputField
                {...props}
                errors={props.formState.errors}
                type="textarea"
                label="Met welke werkzaamheden helpt de mantelzorger (welke taken)?"
                name={"85443"}
                className="col-span-4"
                labelStyles={labelStyles}
                styles={{ ...inputStyles, height: "150px" }}
                rules={{
                  required: "Dit veld is verplicht",
                }}
              />

              <InputField
                {...props}
                errors={props.formState.errors}
                type="select"
                label="Mantelzorger wordt niet betaald als professional of vanuit een PGB"
                name={"85444"}
                options={[
                  {
                    value: 36276,
                    label: "Ja, wordt niet betaald uit PGB",
                  },
                  {
                    value: 36273,
                    label: "Nee, wordt wel betaald uit PGB",
                  },
                ]}
                className="col-span-4 lg:col-span-2"
                labelStyles={labelStyles}
                styles={inputStyles}
                rules={{
                  required: "Dit veld is verplicht",
                }}
              />
              <InputField
                {...props}
                errors={props.formState.errors}
                type="select"
                label="De zorgvrager is mijn"
                name={"85445"}
                options={[
                  {
                    value: 43281,
                    label: "Anders",
                  },
                  {
                    value: 43280,
                    label: "Vrienden",
                  },
                  {
                    value: 43279,
                    label: "Buren",
                  },
                  {
                    value: 43278,
                    label: "Overige familie",
                  },
                  {
                    value: 43277,
                    label: "(schoon) ouder(s)",
                  },
                  {
                    value: 43276,
                    label: "Kind",
                  },
                  {
                    value: 43275,
                    label: "Partner",
                  },
                ]}
                className="col-span-4 lg:col-span-2"
                labelStyles={labelStyles}
                styles={inputStyles}
                rules={{
                  required: "Dit veld is verplicht",
                }}
              />
              <InputField
                {...props}
                errors={props.formState.errors}
                type="select"
                label="Aantal uur mantelzorg per week is meer dan 8 uur "
                name={"85446"}
                options={[
                  {
                    value: 36276,
                    label: "Ja",
                  },
                  {
                    value: 36273,
                    label: "Nee",
                  },
                ]}
                className="col-span-4 lg:col-span-2"
                labelStyles={labelStyles}
                styles={inputStyles}
                rules={{
                  required: "Dit veld is verplicht",
                }}
              />
              <InputField
                {...props}
                errors={props.formState.errors}
                type="text"
                label="Gemiddeld aantal uren mantelzorg per week"
                name={"92376"}
                className="col-span-4 lg:col-span-2"
                labelStyles={labelStyles}
                styles={inputStyles}
                rules={{
                  required: "Dit veld is verplicht",
                }}
              />
              <InputField
                {...props}
                errors={props.formState.errors}
                type="select"
                label="Is dit jaar langer dan 3 maanden aaneengesloten mantelzorg gegeven?"
                name={"85448"}
                options={[
                  {
                    value: 36276,
                    label: "Ja",
                  },
                  {
                    value: 36273,
                    label: "Nee",
                  },
                ]}
                className="col-span-4 lg:col-span-2"
                labelStyles={labelStyles}
                styles={inputStyles}
                rules={{
                  required: "Dit veld is verplicht",
                }}
              />
              <InputField
                {...props}
                errors={props.formState.errors}
                type="number"
                label="Aantal maanden dat dit jaar mantelzorg is/wordt gegeven?"
                name={"85449"}
                className="col-span-4 lg:col-span-2"
                labelStyles={labelStyles}
                styles={inputStyles}
                rules={{
                  required: "Dit veld is verplicht",
                }}
              />
              <InputField
                {...props}
                errors={props.formState.errors}
                type="select"
                label="Zorgvrager en mantelzorger gaan akkoord dat hun gegevens worden opgenomen in het cliëntenbestand van Steunpunt Mantelzorg Verlicht"
                name={"85450"}
                options={[
                  {
                    value: 36276,
                    label: "Ja",
                  },
                  {
                    value: 36273,
                    label: "Nee",
                  },
                ]}
                className="col-span-4"
                labelStyles={labelStyles}
                styles={inputStyles}
                rules={{
                  required: "Dit veld is verplicht",
                }}
              />
            </div>
            <InputField
              {...props}
              errors={props.formState.errors}
              type="select"
              label="Wil de mantelzorger zich aanmelden voor het steunpunt?"
              name={"101818"}
              options={[
                {
                  value: 36276,
                  label: "Ja",
                },
                {
                  value: 36273,
                  label: "Nee",
                },
              ]}
              labelStyles={labelStyles}
              styles={inputStyles}
            />
            <div className="mt-8 flex justify-center">
              <button
                type="submit"
                className="bg-yellow-500 text-white font-bold px-6 py-3 rounded w-full max-w-md hover:bg-yellow-100 hover:!text-yellow-500 hover:border hover:border-yellow-500 hover: transition"
              >
                VERSTUUR
              </button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default Mantelzorgcompliment;
